import React from "react";
import { ErrorOutline as ErrorIcon } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { CardEmptyState } from "../../EmptyState";

interface LastApplicationNoteTakenErrorDisplayProps {
	onRetry?: () => void;
}

const LastApplicationNoteTakenErrorDisplay: React.FC<
	LastApplicationNoteTakenErrorDisplayProps
> = ({ onRetry }) => {
	const { t } = useTranslation();

	return (
		<CardEmptyState
			icon={
				<ErrorIcon
					sx={{
						fontSize: 70,
						color: "white"
					}}
				/>
			}
			title={t("freelancerDetails.errors.loadingError")}
			message={t("freelancerDetails.errors.lastExchangeError")}
			iconBackgroundGradient="linear-gradient(135deg, #ff6b6b 0%, #ee5a52 100%)"
			iconBoxShadow="0 4px 15px rgba(255, 107, 107, 0.3)"
			onRetry={onRetry}
			retryButtonText={t("freelancerDetails.errors.retry")}
			cardTitle={t("freelancerDetails.lastExchange.title")}
			iconSize={{ width: 100, height: 100 }}
			titleVariant="subtitle1"
			messageVariant="body2"
		/>
	);
};

export default LastApplicationNoteTakenErrorDisplay;
